/**
 * ViewFactory
 */
import CommonView from './CommonView';
import Template from './Template';

class ViewFactory {
	constructor( node: any, options: any ) {
		return new CommonView( node, options, Template );
  }
}

export default ViewFactory;
